class SearchFilter {
    constructor (sfContainerId) {
        this.sfContainerEl = document.querySelector(sfContainerId);

        this.filterContainerEl = this.sfContainerEl.querySelector('.filter-container');
        this.entryURL = this.filterContainerEl.getAttribute('data-entry-url');
        
        this.searchContainerEl = this.sfContainerEl.querySelector('.search-container');
        if (this.searchContainerEl) {
            this.searchFieldEl = this.searchContainerEl.querySelector('.search-field');
            this.searchContrBtnEl = this.searchContainerEl.querySelector('.js-search-controller');
        }
        this.searchOpen = false;

        this.mobileFilterSelectEl = this.filterContainerEl.querySelector('#mobile-filter-selector');
        this.serviceQuery = '';

        this.addListeners();
    }

    addListeners () {
        if (this.searchContainerEl) {
            this.searchContrBtnEl.addEventListener('click', this.handleSearchControllerClick.bind(this), true);
        }
        
        if (this.mobileFilterSelectEl) {
            this.mobileFilterSelectEl.addEventListener('change', this.handleMobileFilterSelectChange.bind(this));
            this.changeSelector();
        }
    }

    openSearch () {
       this.searchOpen = true;
       
       const filterContainerElWidth = this.filterContainerEl.offsetWidth;
       this.filterContainerEl.classList.add('nowrap');
       this.filterContainerEl.classList.add('hidden');
       this.searchContainerEl.style.width = filterContainerElWidth + 58 + 'px';
       this.searchContainerEl.classList.add('open');
    }

    closeSearch () {
        this.searchOpen = false;

        this.filterContainerEl.classList.remove('hidden');
        this.searchContainerEl.style.width = '';
        this.searchContainerEl.classList.remove('open');
        setTimeout(() => { this.filterContainerEl.classList.remove('nowrap'); }, 350);
    }

    handleSearchControllerClick (event) {
        event.preventDefault();
        event.stopPropagation();

        if (!this.searchOpen) {
            this.openSearch();
        } else {
            this.closeSearch();
        }
    }

    changeSelector () {
        this.serviceQuery = this.mobileFilterSelectEl.getAttribute('data-service-query');
        this.mobileFilterSelectEl.value = this.serviceQuery;
    }

    handleMobileFilterSelectChange (event) {
        this.serviceQuery = event.target.value;

        if (this.serviceQuery.length && this.serviceQuery !== '?service=') {
            window.location = this.entryURL + this.serviceQuery;
        } else {
            window.location = this.entryURL;
        }
    }
}

const sfBlocks = document.querySelectorAll('.filter-search');

for (const sfEl of sfBlocks) {
    const targetId = sfEl.getAttribute('id');
    if (targetId) {
        const targetObj = new SearchFilter('#' + targetId);
    }
}